import React, { useCallback, useMemo } from "react";
import { MainLayout } from "../layout/mainLayout";
import { LoadingIndicator } from "../framework/loadingIndicatorNew";
import { MonitorViewMap } from "./monitorViewMap";
import { MonitorViewSidebar } from "./sidebar/monitorViewSidebar";
import { useAppSelector } from "../../framework/customStore";
import { MonitorViewMainLayoutProps } from "../../models/monitorView/monitorViewTypes";
import { useFilteredFleetData } from "../../hooks/useFilteredFleetData";

export const MonitorViewMainLayout = ({
    positions,
    loading,
    workShifts,
    transportOrders,
    reloadKey,
    onRefresh,
}: MonitorViewMainLayoutProps) => {
    const handleRefresh = useCallback(() => onRefresh(), [onRefresh]);

    const isVehicleRouteView = useAppSelector(
        (state) => state.monitorView.isVehicleRouteView
    );
    const mapData = useAppSelector((state) => state.monitorView.mapData);

    const {
        filteredVehicleData,
        filteredEmployeeData,
        countByPrimaryFilter,
        fleetSummaryTotals,
        countByWorkTimeType,
        countByDrivingStatus,
        positionByEmployeeId,
    } = useFilteredFleetData({ positions, workShifts, transportOrders });

    const vehiclesAndEmployeesSidebarProps = useMemo(
        () => ({
            vehicleData: filteredVehicleData,
            employeeData: filteredEmployeeData,
            countByPrimaryFilter,
            transportOrders,
            positionByEmployeeId,
            countByWorkTimeType,
            countByDrivingStatus,
        }),
        [
            filteredVehicleData,
            filteredEmployeeData,
            countByPrimaryFilter,
            transportOrders,
            positionByEmployeeId,
            countByWorkTimeType,
            countByDrivingStatus,
        ]
    );

    const mapDataMemo = useMemo(() => {
        return isVehicleRouteView ? mapData : filteredVehicleData;
    }, [filteredVehicleData, isVehicleRouteView, mapData]);

    return (
        <MainLayout
            noPadding
            sideComponentSide="left"
            sideComponent={
                <MonitorViewSidebar
                    fleetSummaryTotals={fleetSummaryTotals}
                    vehiclesAndEmployeesSidebarProps={
                        vehiclesAndEmployeesSidebarProps
                    }
                />
            }
            sideOverFlowHidden
        >
            <>
                <LoadingIndicator loading={loading} />
                <MonitorViewMap
                    loading={loading}
                    data={mapDataMemo}
                    onRefresh={handleRefresh}
                    reloadKey={reloadKey}
                />
            </>
        </MainLayout>
    );
};
